import { Component, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';

@Component({
    selector: 'app-reports-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnChanges {

    @Input() ReportName;
    @Input() OrganizationName;
    @Input() dateFrom;
    @Input() dateTo;
    @Input() selectedWindow;

    @Input() cols;
    @Input() products;
    @Input() loading;
    @Input() showRows;
    @Input() IsShowReportTemplate;
    @Input() firstPage;
    @Input() noContactFindOrLoadingText;

    first = 0;
    tableShowMore: number[] = null;


    constructor() { }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.products?.currentValue) {
            this.products = changes?.products?.currentValue;
            this.generateShowMore(this.products?.length);
            this.resetPagination();
        }

        if (changes?.cols?.currentValue) {
            // console.log(changes?.cols?.currentValue);
        }

    }


    generateShowMore(counts: number = 0) {
        this.tableShowMore = null;
        this.showRows = 15;
        if (counts > this.showRows) {
            this.tableShowMore = [this.showRows, 30];

            if (counts > 30) {
                this.tableShowMore.push(50);
            }

            if (counts > 50) {
                this.tableShowMore.push(100);
            }
        }
    }

    //Rset the pagination
    resetPagination() {
        this.first = 0;
    }

}
